export class SaveData {
  filter: string;
  itemArray: Array<number>;

  constructor() {
    this.filter = '';
    this.itemArray = [];
  }
}
